import React from 'react';

import { App } from './App';


export const Root = () => (
  <div>
    <App />
  </div>
);
